import {eyePose} from './StudioFilters';

// Account-earned accessories, anchored to the same eye pose as the other filters.
export function drawWorkshopReward(ctx, landmarks, reward) {
 const pose=eyePose(landmarks);
 ctx.save();
 try {
  ctx.translate(pose.x,pose.y);ctx.rotate(pose.angle);ctx.scale(pose.distance,pose.distance);
  ctx.lineWidth=.035;ctx.lineJoin='round';
  const oval=(x,y,rx,ry,color)=>{ctx.fillStyle=color;ctx.beginPath();ctx.ellipse(x,y,rx,ry,0,0,Math.PI*2);ctx.fill();};
  if(reward==='artist'){
   ctx.save();ctx.translate(0,-.1);ctx.scale(1.1,1.1);
   oval(-.12,-1.05,1.03,.4,'#38234f');
   oval(-.2,-1.17,.86,.3,'#8053ab');
   ctx.strokeStyle='#d2a9ec';ctx.beginPath();ctx.moveTo(-.9,-1.02);ctx.quadraticCurveTo(-.15,-.78,.78,-1.04);ctx.stroke();
   ctx.fillStyle='#38234f';ctx.fillRect(-.25,-1.57,.1,.2);
   // A paintbrush tucked beside the beret.
   ctx.strokeStyle='#d59c57';ctx.lineWidth=.07;ctx.beginPath();ctx.moveTo(.65,-.91);ctx.lineTo(.97,-1.5);ctx.stroke();
   oval(1,-1.57,.055,.12,'#66dfd7');
   ctx.restore();
   ['#ff739d','#66dfd7','#ffd372'].forEach((color,i)=>{
    oval(-.68+i*.14,.42+i*.09,.085,.04,color);
    oval(.65-i*.13,.5+i*.08,.065,.045,color);
   });

  }else if(reward==='ceo'){
   ctx.strokeStyle='#efca72';ctx.lineWidth=.045;
   ctx.beginPath();ctx.ellipse(-.5,0,.3,.24,0,0,Math.PI*2);ctx.stroke();
   ctx.fillStyle='rgba(212,238,255,.12)';ctx.fill();
   ctx.lineWidth=.022;ctx.beginPath();ctx.moveTo(-.79,.05);ctx.bezierCurveTo(-1.15,.7,-.9,1.25,-.67,.93);ctx.stroke();
   ctx.fillStyle='#172b43';ctx.strokeStyle='#efca72';ctx.lineWidth=.03;
   ctx.beginPath();ctx.moveTo(0,1.65);ctx.lineTo(-.46,1.4);ctx.lineTo(-.46,1.94);ctx.closePath();ctx.fill();ctx.stroke();
   ctx.beginPath();ctx.moveTo(0,1.65);ctx.lineTo(.46,1.4);ctx.lineTo(.46,1.94);ctx.closePath();ctx.fill();ctx.stroke();
   oval(0,1.66,.105,.13,'#efca72');
  }
 }finally{ctx.restore();}
}
